import Translations from '../Translations';
import React, {
    useEffect,
    useState,
} from 'react';
import {
    Modal,
    Button,
    Message,
    Icon,
} from 'semantic-ui-react';

const ModalError = (props) => {

    const {
        desc,
        open,
        onSetOpen
    } = props;

    return (
        <Modal
            open={open}
            dimmer="inverted"
        >
            <Modal.Content>
                <Message negative icon>
                    <Icon name='ban' />
                    <Message.Content>
                        {desc}
                    </Message.Content> 
                </Message>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    content={<Translations text="common.okay" backup={"Ok"} />}
                    primary
                    onClick={() => onSetOpen(false)}
                    fluid
                />
            </Modal.Actions>
        </Modal>
    );

};

export default ModalError;